import config from 'config/socket/chat';
import { io } from 'socket.io-client';

const { webSocket } = config;

const socketStaff = io(webSocket.baseUrlWebSocketStaff, {
  autoConnect: false,
  secure: true,
  transports: ['websocket', 'webtransport']
});

export default socketStaff;
